import { action, orchestrator } from 'satcheljs';
import { addThemeData } from 'owa-theme/lib/mutators/addThemeData';

const RESOURCE_REGEX = /fabric\.color\.variables\.theme\.(\w+)(\.dark)?\.json/;
let resourcesLoaded = false;

function getThemeResourceContext() {
    return require.context(
        '../resources',
        false,
        // Can't use the above const here, as webpack needs a hard-coded value here.
        /fabric\.color\.variables\.theme\.(\w+(\.dark)?)\.json/
    );
}

export const loadAllThemeResources = action('loadAllThemeResources');

orchestrator(loadAllThemeResources, () => {
    if (resourcesLoaded) {
        // No need to do this repeatedly
        return;
    }

    const context = getThemeResourceContext();
    context.keys().forEach(resourceFile => {
        let regexMatches = RESOURCE_REGEX.exec(resourceFile);
        addThemeData(
            regexMatches[1] /* themeId */,
            !!regexMatches[2] /* isDarkTheme */,
            context(resourceFile)
        );
    });
    resourcesLoaded = true;
});
